import React, { useEffect, useState } from 'react';
import { Form, Input, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import './AsiaMilesEdit.scss';
import DrawerFormContainer from 'components/drawerFormContainer/DrawerFormContainer';
import { fetchAndUpdateProfileWithPartialProperties } from 'services/profileService';
import { LoyaltyAccount } from 'types/dto/profile';
// import { useSession } from 'context/SessionContext';

interface AsiaMilesEditProps {
  visible: boolean;
  onClose: () => void;
  onSave?: () => void;
  loyaltyAccount?: LoyaltyAccount;
}

export interface AsiaMilesFormData {
  asiaMilesNo: string;
}

const AsiaMilesEdit: React.FC<AsiaMilesEditProps> = ({
  visible,
  onClose,
  onSave,
  loyaltyAccount,
}) => {
  const { t } = useTranslation('profile');
  const { t: tCommon } = useTranslation('common');
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const { session } = useSession();

  const handleValuesChange = (changedValues: any) => {
    const fieldNames = Object.keys(changedValues);
    if (fieldNames.length > 0) {
      const fieldsToUpdate = fieldNames.map(name => ({
        name: name as any,
        errors: [],
      }));
      form.setFields(fieldsToUpdate);
    }
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);
      const values = await form.validateFields();
      // console.log('Asia Miles number saved:', values);

      try {
        await fetchAndUpdateProfileWithPartialProperties(loyaltyAccount?.unique_id || '', { asia_miles_number: values.asiaMilesNo, });
        onSave?.();
      } catch (error) {
        notification.error({
          message: tCommon('error.updateAsiaMilesFailed'),
          description: (error as Error).message,
          duration: 1.5,
        });
      }
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ asiaMilesNo: loyaltyAccount?.asia_miles_number });
    }
  }, [visible, loyaltyAccount, form]);

  // Asia Miles number validation rules
  const asiaMilesValidationRules = [
    {
      required: true,
      message: t('asiaMilesEdit.asiaMilesRequired'),
    },
    {
      pattern: /^\d{10}$/,
      message: t('asiaMilesEdit.asiaMilesInvalid'),
    },
  ];

  return (
    <DrawerFormContainer
      title={t('asiaMilesEdit.title')}
      visible={visible}
      onClose={() => {
        onClose();
      }}
      onSave={handleSave}
      isSubmitting={isSubmitting}
    >
      <Form
        form={form}
        layout="vertical"
        validateTrigger="onSubmit"
        onValuesChange={handleValuesChange}
        initialValues={{ asiaMilesNo: loyaltyAccount?.asia_miles_number }}
        className="asia-miles-form"
      >
        <Form.Item
          name="asiaMilesNo"
          label={t('asiaMilesEdit.asiaMilesLabel')}
          rules={asiaMilesValidationRules}
        >
          <Input
            type="tel"
            placeholder={t('asiaMilesEdit.asiaMilesPlaceholder')}
            className="form-input asia-miles-input"
            maxLength={10}
            showCount
          />
        </Form.Item>
      </Form>
    </DrawerFormContainer>
  );
};

export default AsiaMilesEdit;